import { api } from '../api/client';
import { API_HEALTH_URL } from '../utils';

/**
 * GET /health — the API's liveness probe, which since 2026-09-23 also says
 * which build answered: { ok, version, commit, startedAt, uptime }
 * (keepr-api SCHEMA.md "Release identity"). Public and database-free, so it
 * is cheap enough to ask whenever a person opens the account menu. An older
 * API answers { ok: true } alone; callers treat a missing version as unknown.
 */
export async function getApiHealth() {
	const { data } = await api.get(API_HEALTH_URL, { timeout: 5000 });
	return data;
}

export default getApiHealth;
